const productAttributeType = {
  GET_ALL_PRODUCTS: 'GET_ALL_PRODUCTS',
  CLEAR_REDUCER: 'CLEAR_REDUCER',
  GET_ALL_FACTORIES: 'GET_ALL_FACTORIES',
  UPDATE_TOTAL_COUNT: 'UPDATE_TOTAL_COUNT',
};

export default productAttributeType;
